import React from 'react';

interface Props {
    level: number
}

export default function VideoFeedTelemetry(props: Props) {
	const { level } = props;
	return (
        <div className="volume-bar-container">
			<div className="volume-bar-fill" style={{ height: `${level}%` }} />
		</div>
	);
}
